import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import NineBoxGridBoxEmployee from "../../../state/shapes/NineBoxGridBoxEmployee"
import AreaChart from "../generic/AreaChart"
import { formatDecimalForDisplay } from "../../../utils/formatting-utils"
import { em } from "polished"

class TableRow extends Component {
  state = {
    showComments: false,
    hover: false,
  }
  getRiskLevel = (riskLevel) => {
    switch (riskLevel) {
      case 1:
        return <span style={{ color: "limegreen" }}>{this.props.t("Common.Low")}</span>
      case 2:
        return <span style={{ color: "orange" }}>{this.props.t("Common.Medium")}</span>
      case 3:
        return <span style={{ color: "red" }}>{this.props.t("Common.High")}</span>
      default:
        return ""
    }
  }
  toggleHoverOn = () => {
    this.setState({ hover: true })
  }
  toggleHoverOff = () => {
    this.setState({ hover: false })
  }
  showComments = () => {
    this.setState({ showComments: true })
  }
  hideComments = () => {
    this.setState({ showComments: false })
  }
  render() {
    const {
      t,
      emp,
      showPotentialScore,
      showPerformanceScore,
      showEngagementScore,
      showNextJob,
      showDesiredLocation,
      showSuccessors,
      showPageGroupDetails,
      index,
      totalItemsOnCurrentPage,
    } = this.props

    let hoverStyle
    let tableRowStyle = { border: "1px solid darkgrey" }
    let detailsNextJobRow = {
      borderLeft: "1px solid darkgrey",
      borderRight: "1px solid darkgrey",
      borderTop: "none",
      borderBottom: "none",
    }
    let detailsDesiredLocationRow = {
      borderLeft: "1px solid darkgrey",
      borderRight: "1px solid darkgrey",
      borderTop: "none",
      borderBottom: "none",
    }
    let detailsSuccessorsRow = {
      borderLeft: "1px solid darkgrey",
      borderRight: "1px solid darkgrey",
      borderTop: "none",
      borderBottom: "none",
    }

    let pageGroupRow = {
      borderLeft: "1px solid darkgrey",
      borderRight: "1px solid darkgrey",
      borderTop: "none",
      borderBottom: "1px solid darkgrey",
    }

    if (this.state.hover) {
      hoverStyle = { color: "black", cursor: "pointer" }
    } else {
      hoverStyle = { color: "black", cursor: "default" }
    }

    if (this.state.showComments) {
      tableRowStyle = {
        borderTop: "1px solid darkgrey",
        borderLeft: "1px solid darkgrey",
        borderRight: "1px solid darkgrey",
        borderBottom: "none",
      }

      // If it's the last box on the page we need to tweak the style else the
      // bottom border isn't applied and it looks nasty.
      if (index === totalItemsOnCurrentPage - 1) {
        // If only nextJob is populated
        if (emp.nextJob != null && emp.nextLocation == null && emp.successors.length == 0) {
          detailsNextJobRow = {
            borderLeft: "1px solid darkgrey",
            borderRight: "1px solid darkgrey",
            borderTop: "none",
            borderBottom: "1px solid darkgrey",
          }
        }

        // If only nextLocation is populated, or
        // nextJob and nextLocation is populated
        if (
          (emp.nextJob == null && emp.nextLocation != null && emp.successors.length == 0) ||
          (emp.nextJob != null && emp.nextLocation != null && emp.successors.length == 0)
        ) {
          detailsDesiredLocationRow = {
            borderLeft: "1px solid darkgrey",
            borderRight: "1px solid darkgrey",
            borderTop: "none",
            borderBottom: "1px solid darkgrey",
          }
        }

        // If only successors is populated, or
        // nextJob and successors is populated, or
        // desiredLocation and successors is populated,
        // all of the properties are populated
        if (
          (emp.nextJob == null && emp.nextLocation == null && emp.successors.length > 0) ||
          (emp.nextJob != null && emp.nextLocation == null && emp.successors.length > 0) ||
          (emp.nextJob == null && emp.nextLocation != null && emp.successors.length > 0) ||
          (emp.nextJob != null && emp.nextLocation != null && emp.successors.length > 0)
        ) {
          detailsSuccessorsRow = {
            borderLeft: "1px solid darkgrey",
            borderRight: "1px solid darkgrey",
            borderTop: "none",
            borderBottom: "1px solid darkgrey",
          }
        }
      }
    }

    let columnCount = 1

    if (showPotentialScore) {
      columnCount += 1
    }

    if (showPerformanceScore) {
      columnCount += 1
    }

    if (showEngagementScore) {
      columnCount += 1
    }

    if (showNextJob || showDesiredLocation || showSuccessors) {
      columnCount += 1
    }

    if (showPageGroupDetails) {
      columnCount += 1
    }

    const successors = emp.successors.map((successor, i) => {
      return <li> {successor.fullName}</li>
    })

    // Page Group Section
    const createSection = (scope) => {
      return (
        <Fragment>
          <b className=" tablesaw-cell-label">{scope.title}</b>
          {/* Small Devices */}
          <span
            style={{ color: "#99abb4", fontSize: "12px" }}
            className="tablesaw-cell-content d-md-none"
          >
            {scope.people[0] && createScopeDetailSection(scope.people[0])}
            {scope.people[1] && createScopeDetailSection(scope.people[1])}
            {scope.people[2] && createScopeDetailSection(scope.people[2])}
          </span>
          {/* Large Devices */}
          <span
            style={{ color: "#99abb4", fontSize: "12px" }}
            className="tablesaw-cell-content d-none d-md-block"
          >
            <span style={{ fontWeight: "bold" }}>{scope.title}:</span>{" "}
            {scope.people[0] && createScopeDetailSection(scope.people[0])}
            {scope.people[1] && createScopeDetailSection(scope.people[1])}
            {scope.people[2] && createScopeDetailSection(scope.people[2])}
          </span>
        </Fragment>
      )
    }

    const createScopeDetailSection = (person) => {
      return (
        <ul>
          <li>{person.name}</li>
          {person.readiness &&
            <li>{t(person.readiness)}</li>
          }
        </ul>
      )
    }

    return (
      <Fragment>
        <tr style={tableRowStyle}>
          <td className="title">
            <b className="tablesaw-cell-label">{t("Common.Employee")}</b>
            <div className="tablesaw-cell-content">
              <p style={{ marginBottom: "0px", color: "black" }}>
                {emp.firstName} {emp.lastName}
              </p>
              <div style={{ fontSize: "12px" }}>
                <span>{emp.locationFullName}</span>
                <br />
                <span>{t(`AppraisalLevels.AppraisalLevel${emp.appraisalLevelId}`)}</span> |{" "}
                <span>{t(`Jobs.JobTitle${emp.jobTitleId}`)}</span> |{" "}
                <span>
                  {emp.managerFirstName} {emp.managerLastName}
                </span>
                <br />
                <span style={{ fontWeight: "bold" }}> {t("Common.RiskOfLeaving")}:</span>{" "}
                {this.getRiskLevel(emp.riskLevel)}
              </div>
            </div>
          </td>
          {/* Potential Score */}
          {showPotentialScore &&
            emp.potentialScores.length === 0 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.EngagementScore")}</b>
                <div className="tablesaw-cell-content">
                  <p style={{ marginBottom: "0px", color: "black", textAlign: "center" }}>-</p>
                </div>
              </td>
            )}
          {showPotentialScore &&
            emp.potentialScores.length === 1 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.PotentialScore")}</b>
                <div className="tablesaw-cell-content">
                  <p style={{ marginBottom: "0px", color: "black", textAlign: "center" }}>
                    {t(emp.potentialCategoryText)}
                  </p>
                </div>
              </td>
            )}
          {showPotentialScore &&
            emp.potentialScores.length > 1 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.PotentialScore")}</b>
                <div className="tablesaw-cell-content">
                  <AreaChart
                    chartHeight={75}
                    chartWidth={200}
                    data={emp.potentialScores}
                    showPercentage={false}
                  />
                </div>
              </td>
            )}
          {/* Performance Score */}
          {showPerformanceScore &&
            emp.performanceScores.length === 0 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.EngagementScore")}</b>
                <div className="tablesaw-cell-content">
                  <p style={{ marginBottom: "0px", color: "black", textAlign: "center" }}>-</p>
                </div>
              </td>
            )}
          {showPerformanceScore &&
            emp.performanceScores.length === 1 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.PerformanceScore")}</b>
                <div className="tablesaw-cell-content">
                  <p style={{ marginBottom: "0px", color: "black", textAlign: "center" }}>
                    {formatDecimalForDisplay(Math.round(emp.performanceScores[0].score))}%
                  </p>
                </div>
              </td>
            )}
          {showPerformanceScore &&
            emp.performanceScores.length > 1 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.PerformanceScore")}</b>
                <div className="tablesaw-cell-content">
                  <AreaChart
                    chartHeight={75}
                    chartWidth={200}
                    data={emp.performanceScores}
                    showPercentage
                  />
                </div>
              </td>
            )}
          {/* Engagement Score */}
          {showEngagementScore &&
            emp.engagementScores.length === 0 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.EngagementScore")}</b>
                <div className="tablesaw-cell-content">
                  <p style={{ marginBottom: "0px", color: "black", textAlign: "center" }}>-</p>
                </div>
              </td>
            )}
          {showEngagementScore &&
            emp.engagementScores.length === 1 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.EngagementScore")}</b>
                <div className="tablesaw-cell-content">
                  <p style={{ marginBottom: "0px", color: "black", textAlign: "center" }}>
                    {formatDecimalForDisplay(Math.round(emp.engagementScores[0].score))}%
                  </p>
                </div>
              </td>
            )}
          {showEngagementScore &&
            emp.engagementScores.length > 1 && (
              <td>
                <b className=" tablesaw-cell-label">{t("Common.EngagementScore")}</b>
                <div className="tablesaw-cell-content">
                  <AreaChart
                    chartHeight={75}
                    chartWidth={200}
                    data={emp.engagementScores}
                    showPercentage
                  />
                </div>
              </td>
            )}
          {/* Other */}
          {/* Smaller Devices */}
          {((showNextJob && emp.nextJob != null) ||
            (showDesiredLocation && emp.nextLocation != null) ||
            (showSuccessors && emp.successors.length > 0) ||
            showPageGroupDetails) &&
            this.state.showComments === false && (
              <td className="d-md-none">
                <div>
                  <button onClick={this.showComments} style={{ width: "100%" }}>
                    {t("Widgets.NineBoxGrid.ShowMoreDetail")}
                  </button>
                </div>
              </td>
            )}
          {((showNextJob && emp.nextJob != null) ||
            (showDesiredLocation && emp.nextLocation != null) ||
            (showSuccessors && emp.successors.length > 0) ||
            showPageGroupDetails) &&
            this.state.showComments === true && (
              <td className="d-md-none">
                <div>
                  <button onClick={this.hideComments} style={{ width: "100%" }}>
                    {t("Widgets.NineBoxGrid.ShowLessDetail")}
                  </button>
                </div>
              </td>
            )}

          {/* Larger Devices */}
          {((showNextJob && emp.nextJob != null) ||
            (showDesiredLocation && emp.nextLocation != null) ||
            (showSuccessors && emp.successors.length > 0) ||
            showPageGroupDetails) &&
            this.state.showComments === false && (
              <td className="d-none d-md-block">
                <div>
                  <span
                    title={t("Widgets.NineBoxGrid.ShowMoreDetail")}
                    onClick={this.showComments}
                    onMouseEnter={this.toggleHoverOn}
                    onMouseLeave={this.toggleHoverOff}
                    className="fa fa-arrow-circle-right"
                    style={hoverStyle}
                  />
                </div>
              </td>
            )}
          {((showNextJob && emp.nextJob != null) ||
            (showDesiredLocation && emp.nextLocation != null) ||
            (showSuccessors && emp.successors.length > 0) ||
            showPageGroupDetails) &&
            this.state.showComments === true && (
              <td className="d-none d-md-block">
                <div>
                  <span
                    title={t("Widgets.NineBoxGrid.ShowLessDetail")}
                    onClick={this.hideComments}
                    onMouseEnter={this.toggleHoverOn}
                    onMouseLeave={this.toggleHoverOff}
                    className="fa fa-arrow-circle-down"
                    style={hoverStyle}
                  />
                </div>
              </td>
            )}

          {/* Empty TD */}
          {!(showNextJob && emp.nextJob != null) &&
            !(showDesiredLocation && emp.nextLocation != null) &&
            !(showSuccessors && emp.successors.length > 0) &&
            !showPageGroupDetails && (
              <td>
                <div>
                  <span>&nbsp;</span>
                </div>
              </td>
            )}
        </tr>

        {/* Extra Comments: Next Job */}
        {showNextJob &&
          emp.nextJob != null &&
          this.state.showComments === true && (
            <tr style={detailsNextJobRow}>
              <td style={{ paddingTop: "0px", lineHeight: "1em" }} colSpan={columnCount}>
                <Fragment>
                  <b className=" tablesaw-cell-label">{t("Common.NextRole")}</b>
                  {/* Small Devices */}
                  <span
                    style={{ color: "#99abb4", fontSize: "12px" }}
                    className="tablesaw-cell-content d-md-none"
                  >
                    {emp.nextJob}
                  </span>
                  {/* Large Devices */}
                  <span
                    style={{ color: "#99abb4", fontSize: "12px" }}
                    className="tablesaw-cell-content d-none d-md-block"
                  >
                    <span style={{ fontWeight: "bold" }}>{t("Common.NextRole")}:</span>{" "}
                    {emp.nextJob}
                  </span>
                </Fragment>
              </td>
            </tr>
          )}

        {/* Extra Comments - Desired Location */}
        {showDesiredLocation &&
          emp.nextLocation != null &&
          this.state.showComments === true && (
            <tr style={detailsDesiredLocationRow}>
              <td style={{ paddingTop: "0px", lineHeight: "1em" }} colSpan={columnCount}>
                <Fragment>
                  <b className=" tablesaw-cell-label">{t("Common.DesiredLocation")}</b>
                  {/* Small Devices */}
                  <span
                    style={{ color: "#99abb4", fontSize: "12px" }}
                    className="tablesaw-cell-content d-md-none"
                  >
                    {emp.nextLocation}
                  </span>
                  {/* Large Devices */}
                  <span
                    style={{ color: "#99abb4", fontSize: "12px" }}
                    className="tablesaw-cell-content d-none d-md-block"
                  >
                    <span style={{ fontWeight: "bold" }}>{t("Common.DesiredLocation")}:</span>{" "}
                    {emp.nextLocation}
                  </span>
                </Fragment>
              </td>
            </tr>
          )}

        {/* Extra Comments - Successors */}
        {showSuccessors &&
          emp.successors.length > 0 &&
          this.state.showComments === true && (
            <tr style={detailsSuccessorsRow}>
              <td style={{ paddingTop: "0px", lineHeight: "1em" }} colSpan={columnCount}>
                <Fragment>
                  <b className=" tablesaw-cell-label">{t("Common.Successors")}</b>
                  {/* Small Devices */}
                  <span
                    style={{ color: "#99abb4", fontSize: "12px" }}
                    className="tablesaw-cell-content d-md-none"
                  >
                    <ul>{successors}</ul>
                  </span>
                  {/* Large Devices */}
                  <span
                    style={{ color: "#99abb4", fontSize: "12px" }}
                    className="tablesaw-cell-content d-none d-md-block"
                  >
                    <span style={{ fontWeight: "bold" }}>{t("Common.Successors")}:</span>{" "}
                    <ul>{successors}</ul>
                  </span>
                </Fragment>
              </td>
            </tr>
          )}
        {/* Extra Page Details */}
        {this.state.showComments === true && showPageGroupDetails && (
          <tr style={pageGroupRow}>
            <td style={{ paddingTop: "0px", lineHeight: "1em" }} colSpan={columnCount}>
              <Fragment>
                <tr>
                  {emp.pageGroupExtraDetail.scopes[0] && 
                  <td>
                    {createSection(emp.pageGroupExtraDetail.scopes[0])}
                  </td>
                  }
                  {emp.pageGroupExtraDetail.scopes[1] && 
                  <td>
                    {createSection(emp.pageGroupExtraDetail.scopes[1])}
                  </td>
                  }
                  {emp.pageGroupExtraDetail.scopes[2] &&
                  <td>
                      {createSection(emp.pageGroupExtraDetail.scopes[2])}
                  </td>
                  }
                </tr>
              </Fragment>
            </td>
          </tr>
        )}
      </Fragment>
    )
  }
}

TableRow.propTypes = {
  emp: PropTypes.shape(NineBoxGridBoxEmployee).isRequired,
  showPotentialScore: PropTypes.bool.isRequired,
  showPerformanceScore: PropTypes.bool.isRequired,
  showEngagementScore: PropTypes.bool.isRequired,
  showNextJob: PropTypes.bool.isRequired,
  showDesiredLocation: PropTypes.bool.isRequired,
  showSuccessors: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  showPageGroupDetails: PropTypes.bool.isRequired,
  totalItemsOnCurrentPage: PropTypes.number.isRequired,
}

export default translate()(TableRow)



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/TableRow.jsx